<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("almacen") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="cambioNegocio()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <router-link
                  :to="{
                    name: 'historial-almacen',
                    params: { idBusiness: idBusiness },
                  }"
                >
                  <button class="btn btn-primary">
                    <i class="far fa-list-alt"></i>
                    {{ $t("historialAlmacen") }}
                  </button>
                </router-link>
                <template>
                    <router-link
                      :to="{
                        name: 'entrada-almacen',
                        params: { idBusiness: this.idBusiness },
                      }"
                    >
                      <button class="btn btn-primary">
                        <i class="fa fa-plus-square"></i>
                        {{ $t("anadirMovimientoAlmacen") }}
                      </button>
                    </router-link>

                    <button
                      @click="comprobarInventario"
                      class="btn btn-primary"
                    >
                      <i class="fa fa-plus-square"></i>
                      {{ $t("nuevoInventario") }}
                    </button>
                </template>
              </div>
            </div>

            <div class="col-md-3 text-right">
              <el-select
                class="select-default filterTag"
                size="large"
                v-model="filter"
                filterable
                @change="cambioFiltro()"
                :placeholder="this.$i18n.t('filtraPorEtiqueta')"
              >
                <el-option
                  v-for="filter in filterTag"
                  class="select-primary"
                  :value="filter.id"
                  :label="filter.name"
                  :key="filter.id"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-md-3 text-right">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-bind:placeholder="$t('buscar')"
                  v-model="searchQuery"
                  @keyup.enter.prevent="searchSubproductos"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="searchSubproductos"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="removeSearch"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-2 col-xs-12 text-right">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>

                <el-dropdown-menu slot="dropdown">
                  <!--<a :href="urlExportPDFListadoExistencia">
                                        <el-dropdown-item>
                                            <strong><i class="fa fa-file-pdf" style="color: red"></i> {{$t("listadoDeExistencia")}}</strong>
                                        </el-dropdown-item>
                                    </a>-->

                  <!--<a :href="urlExportPDFAlmacen">
                                        <el-dropdown-item>
                                            <strong><i class="fa fa-file-pdf" style="color: red"></i> {{$t("exportarValoracion")}}</strong>
                                        </el-dropdown-item>
                                    </a>-->

                  <a :href="urlExportExcelAlmacen">
                    <el-dropdown-item>
                      <strong
                        ><i class="fa fa-file-excel" style="color: green"></i>
                        {{ $t("listadoDeAlmacen") }}</strong
                      >
                    </el-dropdown-item>
                  </a>

                  <!--<a :href="urlExportPDFPedidoStockOpt">
                                        <el-dropdown-item>
                                            <strong><i class="fa fa-file-pdf" style="color: red"></i> {{$t("listadoHastaStockOptimo")}}</strong>
                                        </el-dropdown-item>
                                    </a>-->

                  <a :href="urlExportExcelPedidoStockOpt">
                    <el-dropdown-item>
                      <strong
                        ><i class="fa fa-file-excel" style="color: green"></i>
                        {{ $t("listadoHastaStockOptimo") }}</strong
                      >
                    </el-dropdown-item>
                  </a>

                  <!--<a :href="urlExportPDFPedidoStockMin">
                                        <el-dropdown-item>
                                            <strong><i class="fa fa-file-pdf" style="color: red"></i> {{$t("listadoExistenciaBajoMinimo")}}</strong>
                                        </el-dropdown-item>
                                    </a>-->

                  <a :href="urlExportExcelPedidoStockMin">
                    <el-dropdown-item>
                      <strong
                        ><i class="fa fa-file-excel" style="color: green"></i>
                        {{ $t("listadoExistenciaBajoMinimo") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="row" v-if="isSearch">
            <div class="col-md-12">
              <p>
                <small>{{ showResult }}</small>
              </p>
            </div>
          </div>

          <div class="col-md-12 text-right">
            <p>
              <strong>{{ $t("totalAlmacen") }}: {{ importe | currency }}</strong
              ><br />
              <strong
                >{{ $t("totalAlmacenDto") }}:
                {{ importeDto | currency }}</strong
              >
            </p>
          </div>

          <div v-if="listSubproducts.length > 0">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>
                      <span
                        v-if="ordenarNombre"
                        @click="sortedArrayASC(1), (ordenarNombre = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("nombre") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(1), (ordenarNombre = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("nombre") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarDescripcion"
                        @click="sortedArrayASC(9), (ordenarDescripcion = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("descripcion") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(9), (ordenarDescripcion = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("descripcion") }}
                      </span>
                    </th>
                     <th>
                      <span
                        v-if="ordenarBarcode"
                        @click="sortedArrayASC(10), (ordenarBarcode = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        Código de barras
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(10), (ordenarBarcode = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        Código de barras
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarCategoria"
                        @click="sortedArrayASC(2), (ordenarCategoria = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("categoria") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(2), (ordenarCategoria = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("categoria") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarExistencias"
                        @click="sortedArrayASC(3), (ordenarExistencias = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("existencias") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(3), (ordenarExistencias = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("existencias") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarStockMinimo"
                        @click="sortedArrayASC(4), (ordenarStockMinimo = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("stockMinimo") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(4), (ordenarStockMinimo = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("stockMinimo") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarStockOptimo"
                        @click="sortedArrayASC(5), (ordenarStockOptimo = 0)"
                      >
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("stockOptimo") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(5), (ordenarStockOptimo = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("stockOptimo") }}
                      </span>
                    </th>

                    <th>
                      <span
                        v-if="ordenarPrecios"
                        @click=" sortedArrayASC(6), (ordenarPrecios = 0)  "
                      >
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("precio") }} 
                                 <span style="margin-left: 5%;">
                              <i v-tooltip.top-center="$t('textoInfo')"
                              style="white" class="fa fa-info-circle">
                            </i>
                          </span>
                      </span>
                      <span
                        v-else
                        @click=" sortedArrayDESC(6), (ordenarPrecios = 1)">
                          <i style="color: white" class="fa fa-angle-down"></i>
                              {{ $t("precio") }}
                            <span style="margin-left: 5%;">
                              <i v-tooltip.top-center="$t('textoInfo')"
                              style="white" class="fa fa-info-circle">
                            </i>
                          </span>
                      </span>
                    </th>

                    <th>
                      <span
                        v-if="ordenarPreciosDto"
                        @click=" sortedArrayASC(11), (ordenarPreciosDto = 0)  "
                      >
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("precioDto") }} 
                                 <span style="margin-left: 5%;">
                              <i v-tooltip.top-center="$t('textoInfo')"
                              style="white" class="fa fa-info-circle">
                            </i>
                          </span>
                      </span>
                      <span
                        v-else
                        @click=" sortedArrayDESC(11), (ordenarPreciosDto = 1)">
                          <i style="color: white" class="fa fa-angle-down"></i>
                              {{ $t("precioDto") }}
                            <span style="margin-left: 5%;">
                              <i v-tooltip.top-center="$t('textoInfo')"
                              style="white" class="fa fa-info-circle">
                            </i>
                          </span>
                      </span>
                    </th>

                    <th>
                      <span
                        v-if="ordenarImporte"
                        @click="sortedArrayASC(7), (ordenarImporte = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importe") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(7), (ordenarImporte = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("importe") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarImporteDto"
                        @click="sortedArrayASC(8), (ordenarImporteDto = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importeDto") }}.
                            <span style="margin-left: 5%;">
                          <i
                            v-tooltip.top-center="$t('textoInfoImporteDTO')"
                            style="white" class="fa fa-info-circle">
                          </i>
                        </span>
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(8), (ordenarImporteDto = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("importeDto") }}.

                        <span style="margin-left: 5%;">
                          <i
                            v-tooltip.top-center="$t('textoInfoImporteDTO')"
                            style="white" class="fa fa-info-circle">
                          </i>
                        </span>
                      </span>
                    </th>
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sub, index) in listSubproducts">
                    <td>
                      <div>
                        {{ sub.name }}<br />
                        <span style="font-size:0.9em; color: #757272"
                          >({{ sub.type }} - {{ $t("escandallo") }}:
                          {{ sub.escandallo }})</span
                        >
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ sub.description }}
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ sub.barCode }}
                      </div>
                    </td>
                    <td>
                      <div>{{ sub.nombreCat }}</div>
                    </td>
                    <td>
                      <div>{{ sub.unidades }} / {{ sub.partes }}</div>
                    </td>
                    <td>
                      <div>
                        {{ sub.stockmin }}
                        <template
                          v-if="sub.escandallo > 1 && sub.stockminpartes > 0"
                          >/ {{ sub.stockminpartes }}</template
                        >
                      </div>
                    </td>
                    <td>
                      <div>{{ sub.stockop }}</div>
                    </td>
                    <td align="right">
                      <div>{{ sub.precioCompra | currency }}</div>
                    </td>
                    <td align="right">
                      <div>{{ sub.precioCompraDto | currency }}</div>
                    </td>
                    <td align="right">
                      <div>{{ sub.importe | currency }}</div>
                    </td>
                    <td align="right">
                      <div>{{ sub.importeDto | currency }}</div>
                    </td>
                    <td align="center">
                      <div class="btn btn-primary btn-link">
                        <i
                          v-if="listBusinesses.length > 0"
                          @click="openModal(index, sub.name)"
                          class="fas fa-info-circle"
                          v-tooltip.top-center=" $i18n.t('unidadesEnOtroNegocios') "
                        ></i>
                      </div>
                      <div class="btn btn-primary btn-link">
                        <router-link
                          :to="{
                            name: 'detalle-materia-prima-almacen',
                            params: { idBusiness: idBusiness, idSub: sub.id },
                          }"
                        >
                          <i
                            class="fas fa-chart-line"
                            v-tooltip.top-center="
                              $i18n.t('historialMateriaPrima')
                            "
                          ></i>
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="alert alert-danger" role="alert">
            {{ $t("noHay") }} <strong>{{ $t("subproductosCreados") }}</strong>
            {{ $t("enEsteNegocio") }}
          </div>

          <div class="row" v-if="!isSearch && totalPags > 1">
            <div class="col-md-12">
              <nav>
                <ul class="pagination flex-wrap">
                  <li class="page-item" :class="{ disabled: pag == 1 }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'almacen', params: { pag: pag - 1 } }"
                      v-if="pag != 1"
                      >&laquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&laquo;</span></span
                    >
                  </li>
                  <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'almacen', params: { pag: n } }"
                    >
                      {{ n }}
                    </router-link>
                  </li>
                  <li class="page-item" :class="{ disabled: pag == totalPags }">
                    <router-link
                      class="page-link"
                      :to="{ name: 'almacen', params: { pag: nextPag } }"
                      v-if="pag != totalPags"
                    >
                      &raquo;
                    </router-link>
                    <span v-else class="page-link"
                      ><span aria-hidden="true">&raquo;</span></span
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <modal
        name="modal-subproduct"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("detalleDelSubproducto") }}</h4>
          </div>
          <div class="modal-body">
            <div>
              <div v-if="detalleAlmacen.length > 0" class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("nombreNegocio") }}</th>
                      <th>{{ $t("unidades") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sub in detalleAlmacen">
                      <td>
                        <div>{{ sub.nameBusiness }}<br /></div>
                      </td>
                      <td>
                        <div>{{ sub.unidades }} / {{ sub.partes }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="alert alert-danger" role="alert">
                {{ $t("noHaySubproductosConElMismoNombreEnTusOtrosNegocios") }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-arrow-left"></i>
                {{ $t("volver") }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
    <modal
      name="inventario-existente"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("tienesUnInventarioSinTerminarElDia") }}
            {{ ultimoInventario.fechaInventario | parseDate }}
          </h4>
        </div>
        <div class="modal-body">
          <p>
            {{ $t("pulseElBotonRealizarInventarioPara") }}
            <strong>{{ $t("volverARealizarlo") }}</strong
            >.
          </p>
          <p>
            {{ $t("siDeseas") }}
            <strong>{{ $t("comenzarElInventarioDeNuevo") }}</strong
            >{{ $t("comaMarqueLaCasillaEliminarDatosDeInventarioActual") }}
          </p>
        </div>
        <div class="modal-footer">
          <input
            id="eliminar-datos"
            v-model="ultimoInventario.realizarInventario"
            type="checkbox"
          /><strong
            ><label for="eliminar-datos">{{
              $t("eliminarDatosDelInventarioActual")
            }}</label></strong
          >
          <button @click="generarNuevoInventario()" class="btn btn-success">
            <i class="fas fa-box-open"></i>
            {{ $t("realizarInventario") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import { mapState } from 'vuex';

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    //            this.loading = Loading.service({text: 'Cargando...'});
    this.$store.dispatch("setNameRoute", this.$i18n.t("almacen"));
    this.getBusiness();

    var filtro = this.$route.query.filtro;
    if (filtro !== undefined) {
      this.filter = parseInt(filtro);
    }
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      listBusinesses: [],
      listCategory: ["-"],
      idBusiness: this.$route.params.idBusiness,
      searchQuery: this.$route.params.query,
      isSearch: false,
      pag: this.$route.params.pag,
      totalPags: 0,
      listSubproducts: ["-"],
      filterTag: [],
      filter: 0,
      detalleAlmacen: [],

      indice: 0,
      respuesta: true,

      importeDto: 0,
      importe: 0,

      //ORDENAR
      ordenarNombre: 0,
      ordenarDescripcion: 0,
      ordenarBarcode: 0,
      ordenarCategoria: 0,
      ordenarExistencias: 0,
      ordenarStockMinimo: 0,
      ordenarStockOptimo: 0,
      ordenarReferenciaStockOptimo: 0,
      ordenarPrecios: 0,
      ordenarPreciosDto: 0,
      ordenarImporte: 0,
      ordenarImporteDto: 0,
      accionInventario: false,

      ultimoInventario: {
        hash: "",
        fechaInventario: "",
        realizarInventario: false,
      },
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        this.getListWarehouse();
      } else if (to.params.query) {
        this.query = to.params.query;
        this.getListWarehouse();
      }
    },
  },
  computed: {
    ...mapState(["permiso"]),
    showResult() {
      if (this.listSubproducts.length === 0) {
        return this.$i18n.t("noEncontramosResultadosPara") + this.searchQuery;
      } else {
        const result =
          this.listSubproducts.length === 1
            ? this.$i18n.t("resultado")
            : this.$i18n.t("resultados");
        return (
          this.$i18n.t("mostrando") + this.listSubproducts.length + " " + result
        );
      }
    },
    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
    urlExportPDFListadoExistencia() {
      //NO USADO ACTUALMENTE
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportList/PDF?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportPDFPedidoStockOpt() {
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportListOpt/PDF?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelPedidoStockOpt() {
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportListOpt/Excel?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportPDFPedidoStockMin() {
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportListMin/PDF?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelPedidoStockMin() {
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportListMin/Excel?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportPDFAlmacen() {
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportValoracionAlmacen/PDF?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelAlmacen() {
      // return "../api/public/index.php/almacen/exportValoracionAlmacen/PDF?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
      //  return "../api/public/index.php/almacen/exportValoracionAlmacen/Excel?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
      return (
        this.$store.getters.apiUrl +
        "/almacen/exportValoracionAlmacen/Excel?idBusiness=" +
        this.idBusiness +
        "&filter=" +
        this.filter +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
  methods: {
    comprobarInventario() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "almacen/comprobarInventario", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.ultimoInventario.hash = response.data.result.hash;
              vm.ultimoInventario.fechaInventario = response.data.result.date;
              vm.ultimoInventario.id = response.data.result.id;
              vm.$modal.show("inventario-existente");
            } else {
              /*vm.$router.push({
                name: "control-inventario",
                params: { idBusiness: vm.idBusiness },
              });*/
              vm.crearNuevoInventario();
              
            }
          } else {
            swal({
              title: vm.$t("accesoDenegado"),
              text: response.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    crearNuevoInventario() {

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      this.axios
        .get(this.$store.getters.apiUrl + "almacen/comprobarCambiosDescargados", config)
        .then(function(response) {
          if (response.data.response) {
            
            //El result vendrá con un mensaje de warning si no se va a poder hacer un inventario
            if (response.data.result != true) {
              
              swal({
                title: vm.$t('atencion'),
                text: response.data.result,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "warning",
              });

            } else {

              vm.$router.push({
                name: "control-inventario",
                params: { idBusiness: vm.idBusiness },
              });

            }

          } else {

            swal({
              title: vm.$t("accesoDenegado"),
              text: response.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

          }
          vm.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //ESTE METODO NOS PERMITE SABER SI EL CLIENTE PUEDE HACER INVENTARIOS ONLINE
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 48,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.accionInventario = true;
          } else {
            vm.accionInventario = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    generarNuevoInventario() {
      if (this.ultimoInventario.realizarInventario) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          inventario: this.ultimoInventario,
        };

        let vm = this;
        let controller = "deleteInventario";
        this.axios
          .post(
            this.$store.getters.apiUrl + "almacen/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              vm.$router.push({
                name: "control-inventario",
                params: { idBusiness: vm.idBusiness },
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.$router.push({
          name: "inventario",
          params: { query: this.ultimoInventario.hash },
        });
      }
    },
    sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarNombre = 1;

          function compareNombre(a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareNombre);

        case 2:
          this.ordenarCategoria = 1;

          function compareCategoria(a, b) {
            if (a.nombreCat.toUpperCase() < b.nombreCat.toUpperCase())
              return -1;
            if (a.nombreCat.toUpperCase() > b.nombreCat.toUpperCase()) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareCategoria);

        case 3:
          this.ordenarExistencias = 1;

          function compareExistencias(a, b) {
            if (a.unidades < b.unidades) return -1;
            if (a.unidades > b.unidades) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareExistencias);

        case 4:
          this.ordenarStockMinimo = 1;

          function compareStockMinimo(a, b) {
            if (a.stockmin < b.stockmin) return -1;
            if (a.stockmin > b.stockmin) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareStockMinimo);

        case 5:
          this.ordenarStockOptimo = 1;

          function compareStockOptimo(a, b) {
            if (a.stockop < b.stockop) return -1;
            if (a.stockop > b.stockop) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareStockOptimo);

        case 6:
          this.ordenarPrecios = 1;

          function comparePrecioCompra(a, b) {
            if (a.precioCompra < b.precioCompra) return -1;
            if (a.precioCompra > b.precioCompra) return 1;
            return 0;
          }

          return this.listSubproducts.sort(comparePrecioCompra);

        case 7:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.importe < b.importe) return -1;
            if (a.importe > b.importe) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareImporte);

        case 8:
          this.ordenarImporteDto = 1;

          function compareImporteDto(a, b) {
            if (a.importeDto < b.importeDto) return -1;
            if (a.importeDto > b.importeDto) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareImporteDto);

        
        case 9:
          this.ordenarDescripcion = 0;

          function compareDescripcion(a, b) {
            if (a.description < b.description) return -1;
            if (a.description > b.description) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareDescripcion);

        case 10:
          this.ordenarBarcode = 0;

          function compareBarcode(a, b) {
            if (a.barCode < b.barCode) return -1;
            if (a.barCode > b.barCode) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareBarcode);

        case 11:
          this.ordenarPreciosDto = 1;

          function comparePrecioCompraDto(a, b) {
            if (a.precioCompraDto < b.precioCompraDto) return -1;
            if (a.precioCompraDto > b.precioCompraDto) return 1;
            return 0;
          }

          return this.listSubproducts.sort(comparePrecioCompraDto);
      }
    },
    sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarNombre = 0;

          function compareNombre(a, b) {
            if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareNombre);

        case 2:
          this.ordenarCategoria = 0;

          function compareCategoria(a, b) {
            if (a.nombreCat.toUpperCase() > b.nombreCat.toUpperCase())
              return -1;
            if (a.nombreCat.toUpperCase() < b.nombreCat.toUpperCase()) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareCategoria);

        case 3:
          this.ordenarExistencias = 0;

          function compareExistencias(a, b) {
            if (a.unidades > b.unidades) return -1;
            if (a.unidades < b.unidades) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareExistencias);

        case 4:
          this.ordenarStockMinimo = 0;

          function compareStockMinimo(a, b) {
            if (a.stockmin > b.stockmin) return -1;
            if (a.stockmin < b.stockmin) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareStockMinimo);

        case 5:
          this.ordenarStockOptimo = 0;

          function compareStockOptimo(a, b) {
            if (a.stockop > b.stockop) return -1;
            if (a.stockop < b.stockop) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareStockOptimo);

        case 6:
          this.ordenarPrecios = 0;

          function comparePrecioCompra(a, b) {
            if (a.precioCompra > b.precioCompra) return -1;
            if (a.precioCompra < b.precioCompra) return 1;
            return 0;
          }

          return this.listSubproducts.sort(comparePrecioCompra);

        case 7:
          this.ordenarImporte = 0;

          function compareImporte(a, b) {
            if (a.importe > b.importe) return -1;
            if (a.importe < b.importe) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareImporte);

        case 8:
          this.ordenarImporteDto = 0;

          function compareImporteDto(a, b) {
            if (a.importeDto > b.importeDto) return -1;
            if (a.importeDto < b.importeDto) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareImporteDto);

        case 9:
          this.ordenarDescripcion = 0;

          function compareDescripcion(a, b) {
            if (a.description > b.description) return -1;
            if (a.description < b.description) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareDescripcion);

        case 10:
          this.ordenarBarcode = 0;

          function compareBarcode(a, b) {
            if (a.barCode > b.barCode) return -1;
            if (a.barCode < b.barCode) return 1;
            return 0;
          }

          return this.listSubproducts.sort(compareBarcode);
        
        case 11:
          this.ordenarPreciosDto = 0;

          function comparePrecioCompraDto(a, b) {
            if (a.precioCompraDto > b.precioCompraDto) return -1;
            if (a.precioCompraDto < b.precioCompraDto) return 1;
            return 0;
          }

          return this.listSubproducts.sort(comparePrecioCompraDto);
      }
    },

    openModal(index, nameSubproduct) {
      this.getDetallesWarehouse(nameSubproduct);

      this.$modal.show("modal-subproduct");
    },
    cerrarModal() {
      this.$modal.hide("modal-subproduct");
    },

    cambioNegocio() {
      this.loading = Loading.service({ text: "Cargando..." });
      this.removeSearch();

      this.pag = 1;
      this.totalPags = 0;
      this.filter = 0;
      this.getCategory();
      this.getListWarehouse();
      this.getConfigTpv();

    },
    cambioFiltro() {
      this.removeSearch();

      this.pag = 1;
      this.totalPags = 0;
      this.getListWarehouse();
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;
          //                        vm.loading.close();
          vm.getListWarehouse();
          vm.getCategory();
          vm.getConfigTpv();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getCategory() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getCategoryByBusinesses",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.filterTag = [];

            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("todos"),
                id: 0,
              };

              vm.filterTag.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("todos"),
                  id: 0,
                };

                vm.filterTag.push(category);
              }

              if (i === 0) {
                //TIENE ESTE ID PARA LOCALIZARLO EN LA API
                let category = {
                  name: vm.$t("sinCategoria"),
                  id: -10,
                };

                vm.filterTag.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.filterTag.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    getDetallesWarehouse(nameSubproduct) {
      const controller = "getDetallesWarehouse";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          nameSubproducts: nameSubproduct,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "almacen/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.detalleAlmacen = response.data.result.detalleAlmacen;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getListWarehouse() {
      const controller = this.searchQuery
        ? "searchSubproductInWarehouse/" + this.searchQuery
        : "getListWarehouse";
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          filter: this.filter,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "almacen/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result.almacen;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;

            vm.respuesta = true;

            vm.importeDto = response.data.result.importeTotalDto;
            vm.importe = response.data.result.importeTotal;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        }).finally((_) => {
          vm.loading.close();
        });
    },

    searchSubproductos() {
      if (this.searchQuery !== undefined && this.searchQuery !== "") {
        this.$router.push({
          name: "search-almacen",
          params: { idBusiness: this.idBusiness, query: this.searchQuery },
        });
        this.isSearch = true;
      }
    },
    removeSearch() {
      if (this.searchQuery && this.searchQuery !== "") {
        this.searchQuery = "";
        this.isSearch = false;
        this.$router.push({ name: "almacen" });
        this.getListWarehouse();
      }
    },
  },
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Almacen/Almacen.vue